import React, { useReducer, createContext, useEffect } from "react"

const windowGlobal = typeof window !== "undefined" && window

export const GlobalStateContext = createContext()
export const GlobalDispatchContext = createContext()

const initialState = windowGlobal
  ? {
      isLoggedIn: Boolean(windowGlobal.localStorage.getItem("cornerToken")),
      user: {
        userId: windowGlobal.localStorage.getItem("cornerUserId"),
        token: windowGlobal.localStorage.getItem("cornerToken"),
        expiresIn: windowGlobal.localStorage.getItem("cornerExpDate"),
      },
      hasError: false,
      flashMessage: {},
      profiles: JSON.parse(windowGlobal.localStorage.getItem("cornerProfiles")),
    }
  : {
      isLoggedIn: false,
      user: {},
      hasError: false,
      flashMessage: {},
    }

function reducer(state, action) {
  if (process.env.NODE_ENV === "development") console.log(action.type)
  switch (action.type) {
    case "FLASH_MESSAGE": {
      return {
        ...state,
        hasError: true,
        flashMessage: action.message,
      }
    }
    case "RESET_FLASH_MESSAGE": {
      return {
        ...state,
        hasError: initialState.hasError,
        flashMessage: initialState.flashMessage,
      }
    }
    case "LOGIN": {
      return {
        ...state,
        isLoggedIn: true,
        user: action.data,
      }
    }
    case "LOGOUT": {
      return {
        ...state,
        isLoggedIn: false,
      }
    }
    case "CREATE_PROFILE": {
      return {
        ...state,
        profiles: state.profiles.concat(action.data),
      }
    }
    case "SET_PROFILES": {
      return {
        ...state,
        profiles: action.data,
      }
    }
    case "UPDATE_PROFILE": {
      const profileIndex = state.profiles.findIndex(
        profile => profile.id === action.data.id
      )
      const updatedProfiles = [...state.profiles]
      updatedProfiles[profileIndex] = action.data
      return {
        ...state,
        profiles: updatedProfiles,
      }
    }
    case "DELETE_PROFILE":
      return {
        ...state,
        profiles: state.profiles.filter(
          profile => profile.id !== action.data.id
        ),
      }
    case "UPDATE_SERVICE": {
      const profileIndex = state.profiles.findIndex(
        profile => profile.id === action.data.id
      )
      const updatedProfiles = [...state.profiles]
      updatedProfiles[profileIndex].services = action.data.services
      return {
        ...state,
        profiles: updatedProfiles,
      }
    }
    case "UPDATE_STRIPE": {
      const profileIndex = state.profiles.findIndex(
        profile => profile.id === action.data.id
      )
      const updatedProfiles = [...state.profiles]
      updatedProfiles[profileIndex].stripeAccount = action.data.stripeAccount
      return {
        ...state,
        profiles: updatedProfiles,
      }
    }
    case "UPDATE_PICTURE": {
      const profileIndex = state.profiles.findIndex(
        profile => profile.id === action.data.id
      )
      const updatedProfiles = [...state.profiles]
      updatedProfiles[profileIndex].picture = action.data.picture
      return {
        ...state,
        profiles: updatedProfiles,
      }
    }
    default:
      throw new Error("Bad Action Type")
  }
}

const GlobalContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  useEffect(() => {
    if (state.isLoggedIn) {
      windowGlobal.localStorage.setItem("cornerUserId", state.user.userId)
      windowGlobal.localStorage.setItem("cornerToken", state.user.token)
      windowGlobal.localStorage.setItem("cornerExpDate", state.user.expiresIn)
    } else {
      windowGlobal.localStorage.clear()
    }
  }, [state.isLoggedIn, state.user])

  useEffect(() => {
    if (state.isLoggedIn) {
      const currentTime = new Date().toISOString()
      if (state.user.expiresIn < currentTime) {
        dispatch({ type: "LOGOUT" })
      }
    }
  }, [state.isLoggedIn, state.user.expiresIn])

  useEffect(() => {
    if (state.isLoggedIn && state.profiles)
      windowGlobal.localStorage.setItem(
        "cornerProfiles",
        JSON.stringify(state.profiles)
      )
  }, [state.isLoggedIn, state.profiles])

  return (
    <GlobalStateContext.Provider value={state}>
      <GlobalDispatchContext.Provider value={dispatch}>
        {children}
      </GlobalDispatchContext.Provider>
    </GlobalStateContext.Provider>
  )
}

export default GlobalContextProvider
